import React from "react";

const RecentBg = () => (
  <svg width="100%" height="100%" viewBox="0 0 830 162" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_f_62_558)">
      <path d="M324.772 -618.37C159.329 -140.208 171.755 601.353 1545 -257.701" stroke="url(#paint0_linear_62_558)" strokeWidth="8"/>
    </g>
    <path d="M337.757 -593.686C178.778 -134.176 190.738 578.465 1510.41 -247.053" stroke="url(#paint1_linear_62_558)" strokeOpacity="0.4" strokeWidth="6"/>
    <g filter="url(#filter1_f_62_558)">
      <path d="M898.664 -699.936C437.025 -492.813 -94.5949 24.339 1472.04 435.97" stroke="url(#paint2_linear_62_558)" strokeWidth="8"/>
    </g>
    <path d="M878.583 -673.561C434.959 -474.51 -75.9162 22.4876 1429.58 418.077" stroke="url(#paint3_linear_62_558)" strokeOpacity="0.44" strokeWidth="6"/>
    <defs>
      <filter id="filter0_f_62_558" x="192.513" y="-675.677" width="1410.61" height="872.527" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix"/>
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
        <feGaussianBlur stdDeviation="28" result="effect1_foregroundBlur_62_558"/>
      </filter>
      <filter id="filter1_f_62_558" x="364.668" y="-759.585" width="1164.39" height="1255.42" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix"/>
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
        <feGaussianBlur stdDeviation="28" result="effect1_foregroundBlur_62_558"/>
      </filter>
      <linearGradient id="paint0_linear_62_558" x1="311.382" y1="-657.06" x2="1429.1" y2="-178.815" gradientUnits="userSpaceOnUse">
        <stop stopColor="white" stopOpacity="0"/>
        <stop offset="0.118743" stopColor="#00A177"/>
        <stop offset="0.399583" stopColor="#3A59D1"/>
        <stop offset="0.782483" stopColor="#FE6807"/>
        <stop offset="1" stopColor="white" stopOpacity="0"/>
      </linearGradient>
      <linearGradient id="paint1_linear_62_558" x1="324.888" y1="-630.869" x2="1399.05" y2="-171.283" gradientUnits="userSpaceOnUse">
        <stop stopColor="white" stopOpacity="0"/>
        <stop offset="0.118743" stopColor="#00A177"/>
        <stop offset="0.399583" stopColor="#3A59D1"/>
        <stop offset="0.782483" stopColor="#FE6807"/>
        <stop offset="1" stopColor="white" stopOpacity="0"/>
      </linearGradient>
      <linearGradient id="paint2_linear_62_558" x1="917.671" y1="-736.198" x2="1335.17" y2="405.602" gradientUnits="userSpaceOnUse">
        <stop stopColor="white" stopOpacity="0"/>
        <stop offset="0.118743" stopColor="#00A177"/>
        <stop offset="0.399583" stopColor="#3A59D1"/>
        <stop offset="0.782483" stopColor="#FE6807"/>
        <stop offset="1" stopColor="white" stopOpacity="0"/>
      </linearGradient>
      <linearGradient id="paint3_linear_62_558" x1="896.849" y1="-708.41" x2="1298.09" y2="388.878" gradientUnits="userSpaceOnUse">
        <stop stopColor="white" stopOpacity="0"/>
        <stop offset="0.118743" stopColor="#00A177"/>
        <stop offset="0.399583" stopColor="#3A59D1"/>
        <stop offset="0.782483" stopColor="#FE6807"/>
        <stop offset="1" stopColor="white" stopOpacity="0"/>
      </linearGradient>
    </defs>
  </svg>
);

export { RecentBg };



